import Reference, {ReferenceAttributesSettable} from '~/shared/src/ci/Reference';

import {DATA_UPDATE_REFERENCE} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {setElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * deleteReference Action
 *
 * @memberOf! Actions
 * @param {string} dataContext
 * @param {number} referenceId
 * @param {ReferenceAttributesSettable} attributes
 * @param {string[]} [additionalElusiveDataContexts=[]]
 *
 * @return {void}
 */
const updateReference = ( dataContext : string, referenceId : number, attributes : ReferenceAttributesSettable, additionalElusiveDataContexts : string[] = [] ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: DATA_UPDATE_REFERENCE,
        dataContext,
        referenceId,
        attributes,
        additionalElusiveDataContexts
    } );

    const reference : Reference                           = global.data[ dataContext ]?.references[ referenceId ],
          attributesNames                                 = Object.keys( attributes ),
          changedAttributes : ReferenceAttributesSettable = {};

    if ( reference && attributesNames.length ) {

        // update reference
        for ( const attributeName of attributesNames ) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if ( reference[ attributeName ] !== attributes[ attributeName ] ) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                changedAttributes[ attributeName ] = attributes[ attributeName ];
            }
        }

        if ( Object.keys( changedAttributes ).length ) {
            reference.clone( changedAttributes, true );

            // update ElusiveData
            additionalElusiveDataContexts.unshift( dataContext );
            for ( const elusiveDataContext of additionalElusiveDataContexts ) {
                const elusiveData    = getState().elusiveData?.[ elusiveDataContext ],
                      newElusiveData = {
                          ...elusiveData,
                          data: {
                              ...elusiveData?.data,
                              items     : {
                                  ...elusiveData?.data?.items,
                                  [ reference.srcItemId ] : ( elusiveData?.data?.items?.[ reference.srcItemId ] ?? 0 ) + 1,
                                  [ reference.destItemId ]: ( elusiveData?.data?.items?.[ reference.destItemId ] ?? 0 ) + 1
                              },
                              references: {
                                  ...elusiveData?.data?.references,
                                  [ reference.id ]: ( elusiveData?.data?.references?.[ reference.id ] ?? 0 ) + 1
                              }
                          }
                      };

                dispatch( setElusiveData( elusiveDataContext, newElusiveData ) );
            }
        }
    }
}
export type UpdateReference = typeof updateReference;

export default updateReference;
